<footer class="border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-950">
  <div class="container mx-auto px-4 py-12">
    <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
      <div>
        <button
          class="logo-container relative inline-flex items-center justify-center z-10 cursor-pointer active:scale-95 transition-transform rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
          type="button"
          aria-label="Logo"
          (click)="handleLogoClick()"
          (keydown.enter)="handleLogoClick()"
        >
          <app-logo-with-text />
        </button>
        <p class="mt-4 text-sm text-gray-600 dark:text-gray-300">
          Stay updated with the latest developments in artificial intelligence, machine learning, and related
          technologies.
        </p>
      </div>

      <div class="flex">
        <div class="flex-1">
          <h3 class="text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-gray-100">Explore</h3>
          <ul class="mt-4 space-y-2 -ml-3">
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/"
                class="font-normal text-gray-600 dark:text-gray-300"
                >Home</a
              >
            </li>
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/news"
                class="font-normal text-gray-600 dark:text-gray-300"
                >News</a
              >
            </li>
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/mcp-servers"
                class="font-normal text-gray-600 dark:text-gray-300"
                >MCP Servers</a
              >
            </li>
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/mcp-clients"
                class="font-normal text-gray-600 dark:text-gray-300"
                >MCP Clients</a
              >
            </li>
          </ul>
        </div>

        <div class="flex-1">
          <h3 class="text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-gray-100">Company</h3>
          <ul class="mt-4 space-y-2 -ml-3">
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/about"
                class="font-normal text-gray-600 dark:text-gray-300"
                >About</a
              >
            </li>
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/privacy-policy"
                class="font-normal text-gray-600 dark:text-gray-300"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                hlmBtn
                [size]="'sm'"
                [variant]="'link'"
                routerLink="/terms-of-service"
                class="font-normal text-gray-600 dark:text-gray-300"
                >Terms of Service</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div>
        <h3 class="text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-gray-100">Contact</h3>
        <ul class="mt-4 space-y-2 -ml-3">
          <li class="flex items-center text-sm text-gray-600 dark:text-gray-300">
            <a
              hlmBtn
              [size]="'sm'"
              [variant]="'link'"
              href="mailto:info.summerry@gmail.com"
              class="font-normal text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            >
              <ng-icon hlm [size]="'sm'" [name]="'lucideMail'" class="mr-2" />
              info.summerry&#64;gmail.com
            </a>
          </li>
        </ul>

        <div class="mt-6">
          <h3 class="text-sm font-semibold uppercase tracking-wider text-gray-900 dark:text-gray-100">
            Subscribe to our newsletter
          </h3>
          <div class="mt-4">
            <app-newsletter-subscribe />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 border-t border-gray-200 pt-8 text-center dark:border-gray-700">
      <p class="text-sm text-gray-600 dark:text-gray-400">&copy; {{ currentYear }} Summerry. All rights reserved.</p>
    </div>
  </div>
</footer>

<!-- Easter egg overlay -->
@if (isEasterEggActive()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/80 z-50 easter-egg-overlay">
    <div class="relative">
      <app-easter-egg />
      <div
        class="easter-egg-message fixed inset-x-0 bottom-8 text-white text-center text-base sm:text-lg md:text-xl animate-fade-in z-[99999] px-4 flex flex-row items-center justify-center gap-2 select-none"
      >
        Hi, I'm your lovely AI. Just wanted to say you're doing great 💛
      </div>
    </div>
  </div>
}
